import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import {Dispositivo} from '../enum/dispositivo';


export class MethodsUtils {
  public static detectar_mobile() {
    let check = false; //wrapper no check
    (function(a){
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
        .test(a.substr(0,4))) {
        check = true;
      }
    })(navigator.userAgent||navigator.vendor);
    return check;
  }

  public static detectar_dispositivos(): Dispositivo {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/iPad/i.test(ua) || /Macintosh/i.test(ua)) return Dispositivo.IPAD;
    if (/iPhone|iPod/i.test(ua)) return Dispositivo.MOBILE;

    if (/Android/i.test(ua)) {
      if (/Mobile/i.test(ua)) {
        return Dispositivo.MOBILE;
      } else {
        return Dispositivo.TABLET;
      }
    }

    if (/BlackBerry|IEMobile|Opera Mini/i.test(ua)) return Dispositivo.MOBILE;

    return Dispositivo.DESKTOP;
  }

  public static getPrefixoGrupoUrl(): string | boolean {
    let fullUrl: string = window.location.href;
    let prefixo: string = fullUrl.split("/")[3];

    if (prefixo == null || prefixo == '') {
      return false
    }else{
      return prefixo;
    }
  }

  public static resolucaoPolegadas(){
    const larguraJanela = window.innerWidth;

    const larguraPolegadas = larguraJanela / window.devicePixelRatio / 96;
    return larguraPolegadas;
  }

  public static validarCPFControl(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const strCPF = control.value;
      if (!strCPF) {
        return null;
      }

      let Soma = 0;
      const sanitizedCPF = strCPF.replace('.', '').replace('.', '').replace('-', '');

      if (sanitizedCPF === '00000000000' || sanitizedCPF === '11111111111' || sanitizedCPF === '22222222222' ||
        sanitizedCPF === '33333333333' || sanitizedCPF === '44444444444' || sanitizedCPF === '55555555555' ||
        sanitizedCPF === '66666666666' || sanitizedCPF === '77777777777' || sanitizedCPF === '88888888888' ||
        sanitizedCPF === '99999999999') {
        return { invalidCPF: true };
      }

      for (let i = 1; i <= 9; i++) {
        Soma += parseInt(sanitizedCPF.charAt(i - 1)) * (11 - i);
      }

      let Resto = (Soma * 10) % 11;
      if (Resto === 10 || Resto === 11) {
        Resto = 0;
      }

      if (Resto !== parseInt(sanitizedCPF.charAt(9))) {
        return { invalidCPF: true };
      }

      Soma = 0;
      for (let k = 1; k <= 10; k++) {
        Soma += parseInt(sanitizedCPF.charAt(k - 1)) * (12 - k);
      }

      Resto = (Soma * 10) % 11;
      if (Resto === 10 || Resto === 11) {
        Resto = 0;
      }

      if (Resto !== parseInt(sanitizedCPF.charAt(10))) {
        return { invalidCPF: true };
      }

      return null;
    };
  }

  public static compareArrays(arr1: any[], arr2: any[]): boolean {
    return JSON.stringify(arr1).trim().includes(JSON.stringify(arr2).trim());
  }

  public static validarCPF(strCPF: string){
    var Soma = 0;

    strCPF = strCPF.replace('.', '').replace('.', '').replace('-', '');
    if (strCPF === '00000000000' || strCPF === '11111111111' || strCPF === '22222222222' || strCPF === '33333333333' ||
      strCPF === '44444444444' || strCPF === '55555555555' || strCPF === '66666666666' || strCPF === '77777777777' || strCPF === '88888888888' ||
      strCPF === '99999999999') {
      return false;
    }
    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }

    var Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      return false;
    }

    Soma = 0;
    for (let k = 1; k <= 10; k++) {
      Soma = Soma + parseInt(strCPF.substring(k - 1, k)) * (12 - k)
    }

    Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(10, 11))) {
      return false;
    }
    return true;
  }


  public static validarTelefone(strCelular: string):boolean{
    strCelular = strCelular.replace('(', '').replace(')', '').replace('-', '');
    if(strCelular.length < 10 || strCelular.length > 11){
      return false;
    }
    return true;
  }

  public static validarEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;
    return re.test(email);
  }

  public static getCorPrazo(progresso: number): string {
    if (progresso <= 25 && progresso >= 0) {
      return '#C60000';
    } else if (progresso <= 50) {
      return '#FF8A00';
    } else if (progresso <= 75) {
      return '#FFCE31';
    } else if (progresso <= 100 || progresso > 100) {
      return '#61B460';
    }else{
      return '#d4d4d4';
    }
  }

  public static ordenarAlfabeticamente(a: string, b: string): number {
    const nameA = a.toUpperCase();
    const nameB = b.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }
}
